export default "__VITE_ASSET__5ceb267b__"